import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import qs from 'qs';
const USER_WISE_API_URL = "portfolio/userwise-allocation/";
const UNALLOCATED_API_URL = "portfolio/unallocated-cases/";
const ALLOCATED_API_URL = "portfolio/allocated-cases/";

export const fetchAllocationUsersWise = createAsyncThunk(
  "agency/fetchAllocationUsersWise",
  async (params, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;
      if (!token) return;

      const queryParams = { ...params };
      if (Array.isArray(params?.disposition) && params?.disposition.length > 0) {
        queryParams.disposition = params.disposition.join(',');
      }

      const response = await axios.get(USER_WISE_API_URL, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: queryParams,
      });

      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch users list"
      );
    }
  }
);

export const fetchUnAllocatedCase = createAsyncThunk(
  "agency/fetchUnAllocatedCase",
  async (params, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;
      if (!token) {
        return;
      }

      const queryParams = { ...params };
      if (Array.isArray(params?.disposition) && params?.disposition.length > 0) {
        queryParams.disposition = params.disposition.join(',');
      }

      const response = await axios.get(UNALLOCATED_API_URL, {
        params: queryParams,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch users list"
      );
    }
  }
);

export const fetchAllocatedCase = createAsyncThunk(
  "agency/fetchAllocatedCase",
  async (params, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;
      if (!token) {
        return;
      }
      const queryParams = { ...params };
    
      console.log(params,'slkdjflkdlkfdlkf');
      
      if (Array.isArray(params?.languages) && params?.languages.length > 0) {
        queryParams.languages = params.languages.join(',');
      }
      if (Array.isArray(params?.region) && params?.region.length > 0) {
        queryParams.region = params.region.join(',');
      }

      if (Array.isArray(params?.portfolios) && params?.portfolios.length > 0) {
        queryParams.portfolio = params.portfolios.join(',');
        delete queryParams.portfolios; 
      }
    
      if (Array.isArray(params?.buckets) && params?.buckets.length > 0) {
        queryParams.bucket = params.buckets.join(',');
        delete queryParams.buckets; 
      }
      if (Array.isArray(params?.branches) && params?.branches.length > 0) {
        queryParams.branch = params.branches.join(',');
        delete queryParams.branches; 
      }

      if (Array.isArray(params?.supervisors) && params?.supervisors.length > 0) {
        queryParams.supervisor = params.supervisors.join(',');
        delete queryParams.supervisors; 
      }

      if (Array.isArray(params?.teamleads) && params?.teamleads.length > 0) {
        queryParams.teamlead = params.teamleads.join(',');
        delete queryParams.teamleads; 
      }

      if (Array.isArray(params?.telecallers) && params?.telecallers.length > 0) {
        queryParams.telecaller = params.telecallers.join(',');
        delete queryParams.telecallers; 
      }
      if (Array.isArray(params?.field_agents) && params?.field_agents.length > 0) {
        queryParams.field_agent = params.field_agents.join(',');
        delete queryParams.field_agents; 
      }
      if (Array.isArray(params?.disposition) && params?.disposition.length > 0) {
        queryParams.disposition = params.disposition.join(',');
      }
      if(params?.intensity && !params?.intensity) {
        queryParams.intensity = params.intensity;
      }

      


    
    
      const response = await axios.get(ALLOCATED_API_URL, {
        params: queryParams,

        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch users list"
      );
    }
  }
);


const initialState = {
  user_wise_list: [],
  user_wise_loading: false,
  error: null,
  unAllocated_case: [],
  unAllocated_case_loading: false,
  allocated_case: [],
  allocated_case_loading: false,
};

const allocationSlice = createSlice({
  name: "allocation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllocationUsersWise.pending, (state) => {
        state.user_wise_loading = true;
        state.error = null;
      })
      .addCase(fetchAllocationUsersWise.fulfilled, (state, action) => {
        state.user_wise_loading = false;
        state.user_wise_list = action.payload;
      })
      .addCase(fetchAllocationUsersWise.rejected, (state, action) => {
        state.user_wise_loading = false;
        state.error = action.payload || "Something went wrong";
        state.user_wise_list = [];
      })



      .addCase(fetchUnAllocatedCase.pending, (state) => {
        state.unAllocated_case_loading = true;
        state.error = null;
      })
      .addCase(fetchUnAllocatedCase.fulfilled, (state, action) => {
        state.unAllocated_case_loading = false;
        state.unAllocated_case = action.payload;
      })
      .addCase(fetchUnAllocatedCase.rejected, (state, action) => {
        state.unAllocated_case_loading = false;
        state.error = action.payload || "Something went wrong";
        state.unAllocated_case = [];
      })
      .addCase(fetchAllocatedCase.pending, (state) => {
        state.allocated_case_loading = true;
        state.error = null;
      })
      .addCase(fetchAllocatedCase.fulfilled, (state, action) => {
        state.allocated_case_loading = false;
        state.allocated_case = action.payload;
      })
      .addCase(fetchAllocatedCase.rejected, (state, action) => {
        state.allocated_case_loading = false;
        state.error = action.payload || "Something went wrong";
        state.allocated_case = [];
      });
  },
});

export default allocationSlice.reducer;
